import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { IPlayEvent } from '../lecture-list-item/lecture-list-item.component';
import { CurchService } from '../providers/church.service';
import { IChurch, IDay, IOrganist, IPreacher, IService, ILiveBroadcast } from '../providers/interfaces';
import { IListMeta, LecturesService } from '../providers/lectures.service';
import { OrganistService } from '../providers/organist.service';
import { TimeService } from '../providers/time.service';
import { VicarService } from '../providers/vicar.service';

const sevendays = 604800000;

@Component({
  selector: 'app-upcoming-list',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './upcoming-list.component.html',
  styleUrls: ['./upcoming-list.component.scss']
})
export class UpcomingListComponent implements OnInit, OnDestroy {

  public days$: Observable<IDay[]>;
  public meta$: Observable<IListMeta>;
  public vicars$: Observable<IPreacher[]>;
  public curches$: Observable<IChurch[]>;
  public organists$: Observable<IOrganist[]>;
  public years$: Observable<number[]>;
  public live$: Observable<ILiveBroadcast[]>;
  public selectedLiveBroadcast: ILiveBroadcast = undefined;

  public page = 1;
  public pageSize = 100;
  public startDate = new Date()
  public endDate = new Date(this.startDate.getTime() + sevendays); // Now + 7 days (in milliseconds)
  public list: IDay[] = [];
  public currentService: number;

  public selectedReferent = null;
  public selectedChurch = null;
  public selectedOrganist = null;
  public selectedYear = null;

  private intervalPID: any;

  constructor(
    private $lectureService: LecturesService,
    private $vicarService: VicarService,
    private $churchService: CurchService,
    private $organistService: OrganistService,
    private $timeService: TimeService
  ) { }

  ngOnDestroy(): void {
    clearInterval(this.intervalPID);
  }

  public listenLive(service: IService) {
    let target;
    switch (service.church.name) {
      case 'Bethelkerk':
        target = 'http://kerkomroep.nl/#/kerken/10388';
        break;
      case 'De Poort':
        target = 'http://kerkomroep.nl/#/kerken/10217';
        break;
      case 'Petrakerk':
        target = 'http://kerkomroep.nl/#/kerken/10390';
        break;
    }

    if (target) {
      window.open(target);
    }
  }

  showYoutubeVideo(broadcast: ILiveBroadcast, event: MouseEvent) {

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (broadcast.youtubeUrl) {
      window.open(broadcast.youtubeUrl);
    }
  }

  public selectBroadcast(broadcast: ILiveBroadcast, event: MouseEvent) {

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (broadcast) {
      if (this.selectedLiveBroadcast && this.selectedLiveBroadcast.url === broadcast.url) {
        this.selectedLiveBroadcast = undefined;
      } else {
        this.selectedLiveBroadcast = undefined;
        setTimeout(() => {
          this.selectedLiveBroadcast = broadcast;
        }, 500);
      }
    }
  }

  ngOnInit() {
    console.log('[UPCOMING-LIST]: Init');

    this.intervalPID = setInterval(() => {
      this.$churchService.dispatchLiveBroadcastAllFetch();
    }, 30000);

    this.fetch();

    this.days$ = this.$lectureService.selectDaysAllFetch();
    this.meta$ = this.$lectureService.meta$.asObservable();
    this.vicars$ = this.$vicarService.selectVicarsAllFetch();
    this.curches$ = this.$churchService.selectChurchesAllFetch();
    this.organists$ = this.$organistService.selectOrganistsAllFetch();
    this.years$ = this.$timeService.selectYearsFetchAll();
    this.live$ = this.$churchService.selectLiveBroadcasts();

    this.$vicarService.dispatchVicarsAllFetch();
    this.$churchService.dispatchChurchesAllFetch();
    this.$organistService.dispatchOrganistsAllFetch();
    this.$churchService.dispatchLiveBroadcastAllFetch();
  }

  filter() {
    this.page = 1;
    console.log('[UPCOMING-LIST]: Filter');
    this.fetch();
  }

  togglePlay($event: IPlayEvent) {
    console.log('[UPCOMING-LIST: toggle play]', $event);
    this.currentService = $event.service;
  }

  fetch() {
    console.log('[UPCOMING-LIST]: Fetch');
    this.$lectureService.dispatchDaysAllFetch({
      page: this.page,
      pageSize: this.pageSize,
      startDate: this.startDate,
      endDate: this.endDate,
      vicarId: this.selectedReferent,
      organistId: this.selectedOrganist,
      churchId: this.selectedChurch,
      year: this.selectedYear,
      sortDirection: 'ASC'
    });
  }

  showMore() {
    this.endDate = new Date(this.endDate.getTime() + sevendays);
    this.fetch();
  }

  paginate(newPage) {
    console.log('[UPCOMING-LIST]: Paginate', newPage);
    this.page = newPage;
    this.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/app/upcoming-list/upcoming-list.component.ts